<template lang="html">
  <div class="wrapper">
    <load-spinner v-if="showSpinner"></load-spinner>
    <b-modal ref="req-result">
      <p class="my-4"
         v-bind:class="{ 'message-success' : this.reqSuccess, 'message-fail': !this.reqSuccess } ">{{
          reqResult
        }}</p>
    </b-modal>

    <b-tabs content-class="mt-3">
      <b-tab title="Компанії менеджерів" lazy @click="clearVariables">
        <b-table :items="managerCompanies" :keys="managerCompaniesKeys"></b-table>
      </b-tab>

      <b-tab title="Компанії без менеджерів" @click="clearVariables" lazy>
        <b-table :items="companiesWithoutManagers" :keys="managerWithoutCompaniesKeys"></b-table>
      </b-tab>

      <b-tab title="Розсилки" active @click="clearVariables" lazy>
        <div class="link">
          <b-link :href="download()">Завантажити звіт</b-link>
        </div>
        <b-row>
          <b-col>
            <label for="datepicker-from">Від</label>
            <b-form-datepicker id="datepicker-from" v-model="dateFromNotifications" @input="getNotifications"
                               class="mb-2"></b-form-datepicker>
          </b-col>
          <b-col>
            <label for="datepicker-till">До</label>
            <b-form-datepicker id="datepicker-till" v-model="dateTillNotifications" @input="getNotifications"
                               class="mb-2"></b-form-datepicker>
          </b-col>
        </b-row>

        <b-table :items="this.notifications" :fields="this.notificationsKeys" striped responsive="sm">
          <template v-slot:cell(Деталі)="row">
            <b-button size="sm" @click="row.toggleDetails" class="mr-2">
              {{ row.detailsShowing ? 'Закрити' : 'Відкрити' }} Деталі
            </b-button>
          </template>
          <template v-slot:row-details="row">
            <b-card>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Повний текст:</b></b-col>
                <b-col>{{ row.item['text'] }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Кількість користувачів</b></b-col>
                <b-col>{{ row.item['Кількість користувачів'] }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Перша кнопка</b></b-col>
                <b-col>{{ row.item['btn1'] }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Кількість натискань першої кнопки</b></b-col>
                <b-col>{{ row.item['nBtn1'] }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Друга кнопка</b></b-col>
                <b-col>{{ row.item['btn2'] }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Кількість натискань другої кнопки</b></b-col>
                <b-col>{{ row.item['nBtn2'] }}</b-col>
              </b-row>
              <b-table :items="row.item['answers']" :fields="row.item['innerFields']" striped responsive="sm">
                <template v-slot:cell(Телефон)="row">
                  <a :href="'tel:' + row.item['Телефон']">{{ row.item['Телефон'] }}</a>
                </template>
              </b-table>
              <b-button size="sm" @click="row.toggleDetails">Закрити Деталі</b-button>
            </b-card>
          </template>

        </b-table>
      </b-tab>

      <b-tab title="Замовлення" @click="clearVariables" lazy>
        <b-row>
          <b-col>
            <label for="datepicker-from-orders">Від</label>
            <b-form-datepicker id="datepicker-from-orders" v-model="dateFromOrders" @input="getNotifications"
                               class="mb-2"></b-form-datepicker>
          </b-col>
          <b-col>
            <label for="datepicker-till-orders">До</label>
            <b-form-datepicker id="datepicker-till-orders" v-model="dateTillOrders" @input="getNotifications"
                               class="mb-2"></b-form-datepicker>
          </b-col>
        </b-row>

        <b-table :items="this.orders" :fields="this.ordersKeys" striped responsive="sm">
          <template v-slot:cell(Деталі)="row">
            <b-button size="sm" @click="row.toggleDetails" class="mr-2">
              {{ row.detailsShowing ? 'Закрити' : 'Відкрити' }} Деталі
            </b-button>
          </template>
          <template v-slot:cell(Телефон)="row">
            <a :href="'tel:' + row.item['Телефон']">{{ row.item['Телефон'] }}</a>
          </template>
          <template v-slot:row-details="row">
            <b-card v-for="order in row.item['orders']" :key="order.id">
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Статус</b></b-col>
                <b-col>{{ parseStatus(order.status) }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Вартість</b></b-col>
                <b-col>{{ order.price }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Дата оформлення</b></b-col>
                <b-col>{{ parseDate(order.createdAt) }}</b-col>
              </b-row>
            </b-card>
            <b-button size="sm" @click="row.toggleDetails">Закрити Деталі</b-button>
          </template>
        </b-table>
      </b-tab>

      <b-tab title="Статистика" @click="clearVariables" lazy>
        <b-list-group>
          <b-list-group-item style="margin-bottom: 28px;">Кількість користувачів: {{ usersAmount }}</b-list-group-item>


          <b-row>
            <b-col>
              <label for="datepicker-from-priceRequests">Від</label>
              <b-form-datepicker id="datepicker-from-priceRequests" v-model="dateFromPriceRequests"
                                 @input="getNotifications"
                                 class="mb-2"></b-form-datepicker>
            </b-col>
            <b-col>
              <label for="datepicker-till-priceRequests">До</label>
              <b-form-datepicker id="datepicker-till-priceRequests" v-model="dateTillPriceRequests"
                                 @input="getNotifications"
                                 class="mb-2"></b-form-datepicker>
            </b-col>
          </b-row>
          <b-list-group-item>Запити вартості:

            <b-table :items="this.pricesRequests" :fields="this.pricesRequestsKeys" striped responsive="sm">
              <template v-slot:cell(Клієнт)="row">
                {{ row.item.info.name }}
              </template>
              <template v-slot:cell(Телефон)="row">
                <a :href="'tel:' + row.item.info.phone">{{ row.item.info.phone }}</a>
              </template>
              <template v-slot:cell(Деталі)="row">
                <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                  {{ row.detailsShowing ? 'Закрити' : 'Відкрити' }} Деталі
                </b-button>
              </template>

              <template v-slot:row-details="row">
                <p v-for="date in row.item.requests">{{ parseDate(date) }}</p>
              </template>

            </b-table>
          </b-list-group-item>
        </b-list-group>
      </b-tab>

    </b-tabs>

  </div>
</template>

<script lang="js">
import LoadSpinner from '../components/LoadSpinner';
import {server} from "@/variables";
import {getStat} from "@/services/Stats.service";

export default {
  name: 'src-components-statistic',
  props: [],
  components: {LoadSpinner},
  mounted() {
    this.getStatFromServer();
  },
  data() {
    return {
      // is used to reload items, to rerender
      reload: false,
      showSpinner: false,
      message: '',
      result: '',

      stat: {},

      managerCompanies: [],
      managerCompaniesKeys: ['Ім\'я', 'Кількість компаній'],

      companiesWithoutManagers: [],
      managerWithoutCompaniesKeys: ['ЄДРПОУ', 'Телефон', 'Назва'],

      notifications: [],
      notificationsKeys: ['Текст', 'Кількість відповідей', 'Деталі'],
      notificationInnerContent: [],
      notificationInnerKeys: ['Назва компанії', 'Ім\'я клієнта', 'Телефон', 'Відповідь', 'Час відповіді'],

      orders: [],
      ordersKeys: ['Ім\'я', 'Телефон', 'Замовлень', 'Деталі'],

      usersAmount: 0,
      pricesRequestsKeys: ['Клієнт', 'Телефон', 'Деталі'],
      pricesRequests: [],

      dateFromNotifications: null,
      dateTillNotifications: null,

      dateFromOrders: null,
      dateTillOrders: null,

      dateFromPriceRequests: null,
      dateTillPriceRequests: null,

      reqSuccess: true,
      reqResult: '',
    }
  },
  methods: {
    showModal() {
      this.$refs['req-result'].show();
      setTimeout(this.$refs['req-result'].hide.call(this), 2000);
    },
    clearVariables() {
      this.dateFromNotifications = null;
      this.dateTillNotifications = null;
      this.dateTillOrders = null;
      this.dateFromOrders = null;
      this.dateFromPriceRequests = null;
      this.dateTillPriceRequests = null;
    },
    parseStatus(status) {
      switch (status.toLowerCase()) {
        case 'approved':
          return 'Підтверджене';
        case 'delivery':
          return 'В дорозі';
        case 'delivered':
          return 'Виконане';
        case 'created':
          return 'Заявка створена, очікуйте обробки менеджером';
      }
    },
    parseDate(date) {
      let d = new Date(+date);
      let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
      let month = (d.getMonth() + 1 < 10) ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
      let year = d.getFullYear();
      return `${day}/${month}/${year} ${d.getHours()}:${d.getMinutes()}`;
    },
    getNotifications() {
      this.getStatFromServer();
    },
    getStatFromServer() {
      this.showSpinner = true;
      this.reload = true;
      getStat({
        dateFromNotifications: +new Date(this.dateFromNotifications),
        dateTillNotifications: +new Date(this.dateTillNotifications),
        dateTillOrders: +new Date(this.dateTillOrders),
        dateFromOrders: +new Date(this.dateFromOrders),
        dateFromPriceRequests: +new Date(this.dateFromPriceRequests),
        dateTillPriceRequests: +new Date(this.dateTillPriceRequests),
      })
          .then(stat => {
            this.managerCompanies = stat['managersWithCompanies'].map(x => {
              return {
                'Ім\'я': x.name,
                'Кількість компаній': x.companies,
              }
            });

            this.companiesWithoutManagers = stat['companiesWithoutManagers'].map(x => {
              return {
                'Назва': x.company.title,
                'Телефон': x.phone,
                'ЄДРПОУ': x.company.edrpou,
              }
            });

            this.notifications = stat['notifications'].map(x => {
              if (!x['firstButton'] && !x['secondButton']) {
                return;
              }
              let text = x['uaText'].length <= 30 ? x['uaText'] : x['uaText'].substring(0, 30) + '...';

              let btn1Companies;
              let btn2Companies;
              if (x['firstButton']) {
                btn1Companies = x['firstButton'].map(c => c.title).join(', ');
              }
              if (x['secondButton']) {
                btn2Companies = x['secondButton'].map(c => c.title).join(', ');
              }

              const firstAnswer = x['firstButton'].map(b => {
                const client = x['users'].find(u => u.companyId === b.id);
                let dateString = '';
                if (b.timestamp) {
                  const date = new Date(+b.timestamp);
                  dateString = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
                }
                return {
                  [this.notificationInnerKeys[0]]: b.title,
                  [this.notificationInnerKeys[1]]: client.name,
                  [this.notificationInnerKeys[2]]: client.phone,
                  [this.notificationInnerKeys[3]]: x['uaButton1'],
                  [this.notificationInnerKeys[4]]: dateString,
                }
              });

              const secondAnswer = x['secondButton'].map(b => {
                const client = x['users'].find(u => u.companyId === b.id);
                let dateString = '';
                if (b.timestamp) {
                  const date = new Date(+b.timestamp);
                  dateString = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
                }
                return {
                  [this.notificationInnerKeys[0]]: b.title,
                  [this.notificationInnerKeys[1]]: client.name,
                  [this.notificationInnerKeys[2]]: client.phone,
                  [this.notificationInnerKeys[3]]: x['uaButton2'],
                  [this.notificationInnerKeys[4]]: dateString,
                }
              });

              return {
                'Текст': text,
                text: x['uaText'],
                'Кількість відповідей': `${[...firstAnswer, ...secondAnswer].length}/${x['listeners']}`,
                btn1: x['uaButton1'],
                btn2: x['uaButton2'],
                nBtn1: firstAnswer.length,
                nBtn2: secondAnswer.length,
                btn1Companies,
                btn2Companies,
                Деталі: true,
                answers: [...firstAnswer, ...secondAnswer],
                innerFields: this.notificationInnerKeys,
              }
            }).filter(Boolean);
            console.log(this.notifications)

            this.orders = stat['orders'].map(x => {
              return {
                'Ім\'я': x['name'],
                'Телефон': x['phone'],
                'Замовлень': x['orders'].length,
                orders: x.orders,
              }
            })

            this.usersAmount = stat['usersAmount'];

            let pricesRequests = [];
            // this.pricesRequests = stat['utils']['pricesRequests'];
            stat['utils'].map(r => {
              let client = pricesRequests.find(pr => pr.info.id === r.clientId);
              if (!client) {
                pricesRequests.push({
                  info: {
                    id: r.clientId,
                    name: r.client.name,
                    phone: r.client.phone,
                  },
                  requests: [],
                });
              }
              client = pricesRequests.find(pr => pr.info.id === r.clientId);
              client.requests.push(r.createdAt)
            });
            this.pricesRequests = pricesRequests;

            this.reload = false;
            this.showSpinner = false;
          })
          .catch((err) => {
            console.log(err);
            this.reload = false;
            this.showSpinner = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          });
    },
    download() {
      const dateFromNotifications = +new Date(this.dateFromNotifications);
      const dateTillNotifications = +new Date(this.dateTillNotifications);
      let params = '';
      let added = false;
      if (dateFromNotifications) {
        params += `${added ? '&' : ''}dateFromNotifications=${dateFromNotifications}`;
        added = true;
      }
      if (dateTillNotifications) {
        params += `${added ? '&' : ''}dateTillNotifications=${dateTillNotifications}`;
        added = true;
      }
      if (added) {
        params = '?' + params;
      }
      return `${server}/stat/polls/report${params}`;
    },
  },
  computed: {},
  watch: {}
}
</script>

<style lang="scss">
.wrapper {
  padding: 16px 32px;

  .form {
    .message {
      margin-bottom: 32px;
    }

    .buttons {
      display: flex;
      justify-content: center;
    }
  }

  .link {
    margin: 32px 0;
  }
}
.message-fail {
  color: red !important;
}

.message-success {
  color: green;
}
</style>
